<cjm-layout-container alignItems="center" layoutType="split-content-left" classesMain="c-about-us-section__content">
	<ng-container main>
		<h2 class="c-vloket-header c-vloket-header--h2" cypressTag="General.Header.H2">
			<span class="c-vloket-text-marking c-vloket-text-marking--line-through">
				{{ i18nKeys.Home.AboutUsSection.Title | translate }}
			</span>
		</h2>
		<p>
			{{ i18nKeys.Home.AboutUsSection.Text | translate }}
		</p>

		<cjm-link
			class="u-margin-bottom-lg"
			[to]="[appRoutePaths.About]"
			[title]="
				i18nKeys.Actions.MoreInformation.title
					| translate: { title: i18nKeys.Home.AboutUsSection.LinkAccessibilityText | translate }
			"
			[noDecoration]="true"
			[icon]="{
				icon: 'fa-chevron-right',
				type: 'fa-solid',
				position: 'right'
			}"
		>
			{{ i18nKeys.Actions.MoreInformation.text | translate }}
		</cjm-link>

		<div class="c-about-us-section__cards" cypressTag="AboutUsSection.Cards">
			@for (card of cards; track card) {
				<div class="c-about-us-section__card" cypressTag="AboutUsSection.Card">
					<h3 class="c-vloket-header c-vloket-header--h6">{{ card?.cardTitle }}</h3>
					<span [outerHTML]="card?.cardDescription"></span>
				</div>
			}
		</div>
	</ng-container>
</cjm-layout-container>
